export default __webpack_public_path__ + "static/media/5.141380f7.jpeg";